import React from "react";
import ThemeForm from "./ThemeForm";

/** Add Theme page — thin wrapper around the reusable ThemeForm. */
const ThemeAdd = () => <ThemeForm mode="add" />;

export default ThemeAdd;
